export default class Resource {
	constructor({
		name,
		lastname,
		username,
		email,
		identification,
		role_id,
		uid,
		additional_info,
		json_properties,
		status_id,
	}) {
		this.name = name || "";
		this.lastname = lastname || "";
		this.username = username || "";
		this.email = email || "";
		this.identification = identification || "";
		this.uid = uid || "";
		this.additional_info = additional_info || {};
		this.json_properties = json_properties || {};
		this.role_id = role_id || {};
		this.status_id = status_id || {};
	}
}
